module.exports = __webpack_public_path__ + "media/images/groups-2c894f3a2e05eeef8deedf291ac9075f.svg";